// extracted by mini-css-extract-plugin
module.exports = {"fontFamily":"Roboto","openNavIcon":"#4266bd"};